import { createContext } from 'react';

const Context = createContext({
  competitions: [],
  refresh: () => {},
  find: () => {},
});

export default Context;
